import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import '@/lib/i18n'; // Initialize i18n before App
import { initSecureStorage } from "@/lib/secureStorage";
import { initAds } from "@/lib/ads";
import App from "./App.tsx";
import "./index.css";

const root = document.getElementById("root")!;
// Remove the inline loader before React hydrates to avoid forced reflow
const loader = document.getElementById("initial-loader");
if (loader) {
  loader.remove();
}

// On native, seed Supabase auth tokens from secure Preferences storage
// before the Supabase client reads localStorage. Non-blocking on web.
initSecureStorage().finally(() => {
  // Fire-and-forget: initialise AdMob on native (no-op on web).
  void initAds();
  // Defer render to next frame so the DOM mutation (loader removal) settles
  // before React measures layout, preventing forced reflow
  requestAnimationFrame(() => {
    createRoot(root).render(
      <HelmetProvider>
        <App />
      </HelmetProvider>
    );
  });
});
